import { render, staticRenderFns } from "./DailyEmailActivity.vue?vue&type=template&id=82544788&"
import script from "./DailyEmailActivity.vue?vue&type=script&lang=js&"
export * from "./DailyEmailActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports